// extracted by mini-css-extract-plugin
export var loadingSpinner = "_redotech-redo-web-lib-loading-redo-animation-loading-spinner";